export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MenuButton.vue?vue&type=template&id=29d32e5e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MenuButton.vue?vue&type=template&id=29d32e5e&scoped=true
// module id = 162
// module chunks = 0